import {HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest} from '@angular/common/http';
import {concatMap, firstValueFrom, from, Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

/*
https://esmiscdev.esu.cityu.edu.hk/rests/ho_api
{
  "ords_url": "",
  "access_token": "XR7OW_4Ju0e9A2GIaFq6nQ",
  "token_type": "bearer",
  "expires_in": 3600
}
 */

class OrdsHttpHandler implements HttpHandler {

  private ordsUrl = environment.ordsUrl;
  private ordsConf: any = null;
  http = inject(HttpClient)

  constructor(private httpHandler: HttpHandler) {
  }

  handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {

    return from(this.getToken(req)).pipe(
      concatMap(([token]) => {
        return this.httpHandler.handle(req.clone({url: `${this.ordsUrl}${req.url}`}));
      })
    )
  }

  async getToken(req: HttpRequest<any>) {
    const headers = new HttpHeaders().set('X-ID-TOKEN', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3MTYyOTEwODAsImV4cCI6MTcxNjMzNTk0MCwicm9sZSI6ImFkbWluIiwidWlkIjoibXVuZ2NoYXUifQ.TMOrryJmc7FumR1l0b0Oe-e2csQRZUvDA9Cnq_l2VnM');
    this.ordsConf = await firstValueFrom(this.http.post(`${this.ordsUrl}/auth`, {}, {headers}));
    console.log(this.ordsConf);
    // if conf is null or token is expired, renew the token
    return ["lsafkjsalfjk"];
  }

}


@Injectable()
export class OrdsHttp extends HttpClient {


  constructor(backend: HttpBackend) {
    super(new OrdsHttpHandler(backend));
  }

}
